import { FeatureSectionType } from "../../components/types";

export const featureSections: FeatureSectionType[] = [
  {
    src: "/landing_page_assets/rive/06.riv",
    fallbackSrc: "/landing_page_assets/home_page/img3.png",
    title: "Full transparency & visibility",
    description: [
      "Verse can automatically extract diagnostic information & supply orders directly from the medical record.",
    ],
    features: [
      {
        icon: "/landing_page_assets/icons/Route.svg",
        text: "Know exactly where every DME order is",
      },
      {
        icon: "/landing_page_assets/icons/SearchCheck.svg",
        text: "No more phone calls or faxes to five DME vendors to track orders. See it all in one place with Verse.",
      },
      {
        icon: "/landing_page_assets/icons/Bolt.svg",
        text: "Save 15+ minutes for every order gone haywire by partnering with Verse.",
      },
    ],
    hasButton: true,
    imageClassName: "tw-aspect-square tw-max-h-[558px]",
  },
  {
    src: "",
    fallbackSrc: "/landing_page_assets/AIExtraction.png",
    title: "AI extraction from the medical record",
    description: [
      "Verse can automatically extract diagnostic information & supply orders directly from the medical record.",
    ],
    features: [
      {
        icon: "/landing_page_assets/icons/Sparkle.svg",
        text: "No more forms and manual data entry - submit an order within 1 minute",
      },
      {
        icon: "/landing_page_assets/icons/Bolt.svg",
        text: "Eliminate back and forth for incomplete documentation",
      },
    ],
    className: "min440:tw-flex-row-reverse",
    imageClassName: "tw-aspect-square tw-max-h-[558px]",
    hasButton: true,
  },
  {
    src: "/landing_page_assets/rive/08.riv",
    fallbackSrc: "/landing_page_assets/home_page/img4.png",
    title: "Handle even the most complex items",
    description: [
      "Verse works for items with complicated reimbursement rules that differ payor by payor, not just the easy stuff.",
    ],
    features: [
      {
        icon: "/landing_page_assets/icons/List.svg",
        text: "Order even the most complex DME items",
      },
      {
        icon: "/landing_page_assets/icons/Heart.svg",
        text: "Verse can handle orders for items with complex coverage criteria, e.g. wound care, ostomy",
      },
    ],
    hasButton: true,
    imageClassName: "tw-aspect-square tw-max-h-[558px]",
  },
];
